import Icon from '@/components/ui/icons/Icon';
import React from 'react';

export const SingleSubjectButton = ({ bgColor, hoverBgColor, textColor, textHoverColor, label, onClick, hideIcon = false }: { bgColor: string; hoverBgColor: string; textColor: string; textHoverColor: string; label: string; onClick: () => void; hideIcon?: boolean }) => {
  return (
    <button onClick={onClick} className={`flex items-center pl-4 pr-6 gap-x-2 font-fractul ${textColor} ${bgColor} ${hoverBgColor} py-6 h-[48px] rounded-full transition-colors transform duration-300 ease-out group`} type='button'> 
      {!hideIcon && <Icon name='arrow-right' className={`transform duration-300 group-hover:translate-x-1 group-hover:${textHoverColor}`} />}
      {label}
    </button>
  );
};
